<template>
  <div class="left">

    <el-aside width="90" style="background-color: #304156" :collapse="this.$store.state.boo">
    <el-menu
     class="el-menu-vertical-demo"
     @open="handleOpen"
     @close="handleClose"
     :collapse-transition="true"
     :unique-opened="true"
     :default-active="$route.path"
      router
      background-color="#304156"
      text-color="#eee"
      :collapse="$store.state.boo"
         >
      <!-- <el-menu-item>
        <template>
          <i class="el-icon-location"></i>
          <span slot="title">首页</span>
        </template>
      </el-menu-item> -->
      <h3>
        <i></i>
        <span :class="{'hide':$store.state.boo}">采销中心</span>

      </h3>
      <el-menu-item index="/dashboard" class="submenu-title-noDropdown">
        <i class="el-icon-menu"></i>
        <span slot="title">
          首页
        </span>
      </el-menu-item>
        <!-- <el-menu-item index="/statistics" class="submenu-title-noDropdown">
            <i class="el-icon-s-order"></i>
            <span slot="title">数据统计</span>
        </el-menu-item> -->
        <el-submenu index="/system">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span slot="title">商家管理</span>
          </template>
          <!-- <el-menu-item index="/system/user">店铺列表</el-menu-item> -->
          <el-menu-item index="/system/role">订单列表</el-menu-item>
          <el-menu-item index="/system/menu">品牌审核</el-menu-item>
          <el-menu-item index="/system/dept">添加店铺</el-menu-item>
          <!-- <el-menu-item index="/system/notice">轮播图管理</el-menu-item> -->
        </el-submenu>
        <el-submenu index="/party">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>商城管理</span>
          </template>
          <!-- <el-menu-item index="/party/member">分类管理</el-menu-item>
           <el-menu-item index="/party/goods">产品管理</el-menu-item> -->
           <el-menu-item index="/party/notice">轮播图管理</el-menu-item>
        </el-submenu>
      <!--   <el-submenu index="/eLife">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>e惠民生</span>
          </template>
          <el-menu-item index="/eLife/policy">政策知晓</el-menu-item>
        </el-submenu>
        <el-submenu index="/ePower">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>党建赋能站</span>
          </template>
          <el-menu-item index="/ePower/lifeInfo">组织生活</el-menu-item>
          <el-menu-item index="/ePower/education">主题教育</el-menu-item>
          <el-menu-item index="/ePower/partyBuilding">党建品牌</el-menu-item>
          <el-menu-item index="/ePower/connection">村集体经济</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/talent">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>人才资源小区</span>
          </template>
          <el-menu-item index="/talent/talentWork">人才工作</el-menu-item>
          <el-menu-item index="/talent/talentPool">人才资源库</el-menu-item>
          <el-menu-item index="/talent/antStar">蚂蚁服务星战</el-menu-item>
          <el-menu-item index="/talent/training">人才需求</el-menu-item>
          <el-menu-item index="/talent/talentCenter">人才中心审核</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/together">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>党群活动阵地</span>
          </template>
          <el-menu-item index="/together/center">党建服务中心</el-menu-item>
          <el-menu-item index="/together/station">初心公园</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/integral">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>我的积分</span>
          </template>
          <el-menu-item index="/integral/rules">积分规则</el-menu-item>
          <el-menu-item index="/integral/supermarket">积分超市</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/eStudy">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>e学习</span>
          </template>
          <el-menu-item index="/eStudy/video">视频学习</el-menu-item>
          <el-menu-item index="/eStudy/theory">理论学习</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/activities">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>党群活动</span>
          </template>
          <el-menu-item index="/activities/law">乡镇（街道）</el-menu-item>
          <el-menu-item index="/activities/close">机关活动</el-menu-item>
          <el-menu-item index="/activities/popularity">两新组织活动</el-menu-item>
          <el-menu-item index="/activities/publication">发布活动</el-menu-item>
          <el-menu-item index="/activities/resident">共筑共建</el-menu-item>
          <el-menu-item index="/activities/front">阵地预约审核</el-menu-item>
        </el-submenu> -->
        <!-- <el-submenu index="/babyWish">
          <template slot="title">
            <i class="el-icon-location"></i>
            <span>微心愿</span>
          </template>
          <el-menu-item index="/babyWish/checkWish">心愿审核</el-menu-item>
        </el-submenu> -->
      </el-menu>
      </el-aside>

  </div>
</template>

<script>
export default {
  data () {
    return {
      isCollapse: true
    }
  },
  watch: {
    // $route(to){
    //   const {name}=to;
    //   this.$router.push({
    //     name
    //   })
    // }
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    }
  }
}
</script>

<style lang="scss">
h3 {
  height: 56px;
  line-height: 56px;
  color: white;
  text-align: center;
  align-items: center;
}
h3 > i {
  display: inline-block;
  width: 28px;
  height: 28px;
  background: url(http://120.46.68.67:8586/static/img/logo.381d6a3e.png)
    no-repeat 0 0/100%;
  vertical-align: middle;
}

* {
  margin: 0;
  padding: 0;
}
h3 > .hide {
  /* display:inline-block;
  width:0;
  overflow: hidden; */
  display: none;
  width: 0;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: 100vh;
  /* border:none; */
}
.el-aside::-webkit-scrollbar {
  display: none;
}
.el-menu {
  border: none;
}
.el-menu--collapse {
  height: 100vh;
  border: none;
}
.icon {
  font-size: 40px;
}
.el-submenu__title>img{
  width: 20px;
  margin: 0 10px;
}
.el-menu-item {
  background-color: #1f2d3d !important;
}
.submenu-title-noDropdown{
  background-color: rgb(48, 65, 86) !important;
}
</style>
